module.exports = __webpack_public_path__ + "img/skin-care-goal-slide3.3f34b2fa.gif";